export const FORM_TABS = {
  DEFAULT: 'default',
  PLATFORM_FEES: 'platformFees',
  QRBILL: 'qrBill',
  PAY_SETTINGS: 'PAY_SETTINGS',
  INTEGRATION_SETTINGS: 'INTEGRATION_SETTINGS',
  KYB: 'KYB',
  KYB_FILES: 'KYB_FILES',
  CHECK_IN_SETTINGS: 'CHECK_IN_SETTINGS',
};
